<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="indicator-create-tab-info">
		<vx-card style="box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1)">
			<div class="vx-row">
				<div class="vx-col w-full flex items-center">
					<feather-icon
						class="g-breadcrumb--title"
						icon="ChevronLeftIcon"
						svgClasses="h-8 w-8"
						@click.prevent="$emit('changeActiveTabEmit', 0)"
					/>
					<vs-breadcrumb
						class="g-breadcrumb--title"
						separator=""
						:items="[{title: $t('general.Return')}]"
						@click.prevent="$emit('changeActiveTabEmit', 0)"
					></vs-breadcrumb>
				</div>
			</div>
			<bread-crumbs
				class="ml-1"
				:title="
					indicatorData.id > 0
						? $t('Crud.Update') + ' ' + $t('Indicators.Indicator')
						: $t('Crud.Create') + ' ' + $t('New') + ' ' + $t('Indicators.Indicator')
				"
				:subTitle="
					indicatorData.id > 0
						? $t('general.SubtitleIndicatorsUpdate')
						: $t('general.SubtitleIndicatorsCreate')
				"
				:sizeTitle="22"
				:lineHeightTitle="27"
				:sizeSubTitle="13"
				:lineHeightSubTitle="16"
			>
			</bread-crumbs>
			<div class="vx-row">
				<div class="vx-col w-full md:w-2/3 indicator-content-form">
					<vx-card no-shadow card-border class="indicator-content-form--card">
						<div class="vx-row">
							<div class="vx-col w-full mb-4">
								<!-- NAME -->
								<label class="g-label" v-text="$t('Name')"></label>
								<vs-input
									v-model="indicatorData.name"
									class="w-full"
									name="item-name"
									v-validate="'required'"
								/>
								<span
									class="text-danger text-sm"
									v-show="errors.has('item-name')"
									v-text="errors.first('item-name')"
								></span>
							</div>
							<div class="vx-col w-full mb-4">
								<!-- url -->
								<label class="g-label" v-text="$t('Object.statusOptions.Url')"></label>
								<vs-input
									v-model="indicatorData.url"
									class="w-full"
									name="url"
									v-validate="'required|url'"
								/>
								<span
									class="text-danger text-sm"
									v-show="errors.has('url')"
									v-text="errors.first('url')"
								></span>
							</div>
							<!-- Description Col -->
							<div class="vx-col w-full mb-4">
								<!-- DESCRIPTION -->
								<label class="g-label" v-text="$t('Description')"></label>
								<vs-textarea
									v-model="indicatorData.description"
									class="w-full"
									name="item-category"
									v-validate="'required'"
									height="95px"
								/>
								<span
									class="text-danger text-sm"
									v-show="errors.has('item-category')"
									v-text="errors.first('item-category')"
								></span>
							</div>
						</div>
					</vx-card>
				</div>
				<div class="vx-col w-full md:w-1/3 indicator-content-form">
					<vx-card no-shadow card-border class="indicator-content-form--card">
						<span class="g-tools--description" v-text="$t('Groups.AssignedGroups')"></span>
						<div class="vx-row mt-4">
							<div class="vx-col md:w-1/5 w-full">
								<div class="o-span--count bg-primary" v-text="assignedGroups.length"></div>
							</div>
							<div class="vx-col md:w-4/5 w-full mb-5">
								<vs-button
									type="border"
									color="#F9841E"
									style="padding: 0.3rem 2.5rem; font-size: 12px; line-height: 15px"
									icon-pack="feather"
									icon="icon-plus"
									@click.prevent="groupMounted = true"
									>{{ $t("ButtonAddTypeConfig") }}
								</vs-button>
							</div>
						</div>
						<hr style="border: 0.75px solid #a3a3a3" />
						<div class="vx-row">
							<vue-perfect-scrollbar class="scroll-area" :settings="settings">
								<vs-list>
									<vs-list-item
										v-for="group in assignedGroups"
										:key="group.id"
										:title="group.name"
										:subtitle="group.hour_init + ' - ' + group.hour_end"
									>
										<vs-button
											color="danger"
											class="mr-2"
											type="flat"
											icon-pack="feather"
											icon="icon-trash-2"
											@click.prevent="removeAssignedGroup(group.id)"
										></vs-button>
									</vs-list-item>
									<p
										v-if="showAlertMissingGroup && assignedGroups.length === 0"
										class="g-label--normal"
									>
										<vs-alert
											:active.sync="activeAlertMissingGroup"
											closable
											icon-pack="feather"
											close-icon="icon-x"
											color="danger"
											:title="$t('Groups.AssigneGroupRequired')"
										>
											{{ $t("Groups.ClickOnButton") }} +
											{{ $t("To") }}
											{{ $t("Groups.AssigneGroupToltip") }}
										</vs-alert>
									</p>
								</vs-list>
							</vue-perfect-scrollbar>
						</div>
					</vx-card>
				</div>
			</div>
		</vx-card>
		<!-- GROUP LIST COMPONENT -->
		<vs-popup :fullscreen="false" :title="null" :active.sync="groupMounted" class="vs-popup--content-custom">
			<bread-crumbs
				:title="$t('Groups.AssignGroups')"
				:subTitle="$t('general.SubtitleGroupsIndicator')"
				:sizeTitle="22"
				:lineHeightTitle="27"
				:sizeSubTitle="13"
				:lineHeightSubTitle="16"
			>
			</bread-crumbs>
			<group-list v-if="groupMounted" :customConfig="groupListConfig" @showPopupEmmit="showPopupGroup" />
		</vs-popup>
		<!-- Save & Reset Button -->
		<div class="vx-row">
			<div class="vx-col w-full">
				<div class="mt-4 flex flex-wrap items-center justify-end">
					<vs-button
						class="mr-2 g-btn--resourcePopup"
						type="border"
						color="danger"
						style="padding: 0.7rem 3.8rem"
						@click.prevent="$emit('changeActiveTabEmit', 0)"
						>{{ $t("Cancel") }}
					</vs-button>
					<vs-button
						id="button-create-loading"
						class="vs-con-loading__container ml-4 g-btn--resourcePopup"
						type="filled"
						color="success"
						:disabled="!this.validateForm"
						@click.prevent="saveChanges"
						>{{ $t("Save") + " " + $t("Indicators.Indicator") }}
					</vs-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
// Store
import moduleIndicator from "@/store/indicator/moduleIndicator.js";
import moduleGroup from "@/store/group/moduleGroup.js";

import GroupList from "@/components/group/GroupListView.vue";
import Indicator from "@/models/Indicator.js";
import Commons from "@/helpers/commons.js";

export default {
	components: {
		vSelect,
		flatPickr,
		GroupList,
		VuePerfectScrollbar,
	},
	props: {
		data: {
			type: Indicator,
			default: () => {
				new Indicator({});
			},
		},
	},
	data() {
		return {
			indicatorData: this.data,
			activeItem: 0,
			update: false,
			resourceMounted: false,
			groupMounted: false,
			resource_id: [],
			group_id: [],
			checkedResources: [],
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			// Style loading
			backgroundLoading: "primary",
			colorLoading: "#fff",
			relatedIds: [],
			//Config Resource List
			groupListConfig: {
				columns: ["name", "hour_init", "hour_end"],
				actionDropdown: false,
				btnAssigGroup: true,
				rowSelectionMultiple: false,
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			showAlertMissingGroup: false,
			activeAlertMissingGroup: true,
		};
	},
	computed: {
		validateForm() {
			return (
				!this.errors.any() &&
				this.indicatorData.name &&
				this.indicatorData.description &&
				this.indicatorData.url
			);
		},
		assignedGroups() {
			return this.$store.state.moduleGroup.groupsActivity;
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
	},
	methods: {
		saveChanges() {
			let groupsIdChecked = this.assignedGroups.length > 0 ? this.assignedGroups[0].id : 0;
			let groupsNameChecked = this.assignedGroups.length > 0 ? this.assignedGroups[0].name : "";
			this.indicatorData.group_id = groupsIdChecked ? groupsIdChecked : 0;
			this.indicatorData.group_name = groupsNameChecked ? groupsNameChecked : "";

			if (this.indicatorData.group_id === 0) {
				this.showAlertMissingGroup = true;
				return;
			}
			if (this.indicatorData.id > 0) {
				this.updateIndicator();
			} else {
				this.createIndicator();
			}
		},
		openLoadingContained() {
			this.$vs.loading({
				background: this.backgroundLoading,
				color: this.colorLoading,
				container: "#button-create-loading",
				scale: 0.45,
			});
		},
		closeLoadingContained() {
			this.$vs.loading.close("#button-create-loading > .con-vs-loading");
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		showPopupGroup(val) {
			this.groupMounted = val;
		},
		initValues() {
			if (this.indicatorData.id) return;
			this.indicatorData = new Indicator({});
		},
		createIndicator() {
			delete this.indicatorData.id;
			this.openLoadingContained();
			this.$store
				.dispatch("moduleIndicator/addIndicatorItem", this.indicatorData)
				.then((res) => {
					this.closeLoadingContained();
					this.$vs.notify({
						color: "success",
						title: this.$t("Indicators.TitleConfirmIndicatorCreate"),
						text: this.$t("Indicators.TextConfirmIndicatorCreate"),
					});
					//this.$router.push({ name: "app-activity-list" });
					this.$emit("changeActiveTabEmit", 0);
				})
				.catch((err) => {
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					this.closeLoadingContained();
					throw new Error(err);
				});
		},
		updateIndicator() {
			this.openLoadingContained();
			this.$store
				.dispatch("moduleIndicator/updateIndicatorItem", this.indicatorData)
				.then((res) => {
					this.closeLoadingContained();
					this.$vs.notify({
						color: "success",
						title: this.$t("Indicators.TitleConfirmIndicatorUpdate"),
						text: this.$t("Indicators.TextConfirmIndicatorUpdate"),
					});
					//this.$router.push({ name: "app-activity-list" });
					this.$emit("changeActiveTabEmit", 0);
				})
				.catch((err) => {
					this.closeLoadingContained();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					throw new Error(err);
				});
		},

		getAssignedGroups() {
			Commons.openLoadingButton.call(this, "btn-show-assigned-group");
			const data = {
				ids: [this.indicatorData.group_id],
				fields: ["id", "name", "address", "dirtrad", "hour_init", "hour_end"],
			};
			this.$store
				.dispatch("moduleGroup/getGroupsByFilter", data, {
					component: "activitycreate",
				})
				.then((res) => {
					Commons.closeLoadingButton.call(this, "btn-show-assigned-group");
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, "btn-show-assigned-group");
					throw new Error(err);
				});
		},
		removeAssignedGroup(id) {
			// Delete item form store
			this.$store.dispatch("moduleGroup/removeGroupActivity", id);
			// Delete item from local
			const ItemIndex = this.indicatorData.group_id.findIndex((p) => p === id);
			this.indicatorData.group_id.splice(ItemIndex, 1);
		},
	},
	filters: {
		labelAsignTo(value) {
			if (value === "Seleccione") {
				return "Seleccione una opción en el campo Asignar a";
			} else {
				return value + "s";
			}
		},
	},
	created() {
		if (!moduleIndicator.isRegistered) {
			this.$store.registerModule("moduleIndicator", moduleIndicator);
			moduleIndicator.isRegistered = true;
		}

		// register Module Group
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}
	},
	mounted() {
		if (this.indicatorData.id <= 0) {
			this.initValues();
			this.$validator.reset();
		} else {
			this.openLoading();
			this.$store
				.dispatch("moduleIndicator/fetchIndicatorById", this.indicatorData.id)
				.then((res) => {
					this.indicatorData = new Indicator(res.data[0]);
					const data = {
						ids: [this.indicatorData.group_id],
						fields: ["id", "name", "hour_init", "hour_end"],
					};
					return this.$store.dispatch("moduleGroup/getGroupsByFilter", data, {
						component: "IndicatorCreate",
					});
				})
				.then((res) => {
					this.update = true;
					this.closeLoading();
					return res;
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		}
	},
	beforeDestroy() {
		this.$store.dispatch("moduleGroup/cleanGroupActivity");
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: 5px;
	min-height: auto;
	max-height: 310px;
}

.indicator-content-form {
	width: auto;
	height: 350px;

	.indicator-content-form--card {
		height: 100%;
	}
}
</style>
